
/**
 * Representa um token de autenticação.
 */
export class Token {
    
    /**
     * O token de acesso utilizado para autenticação.
     */
    public access_token: string;

    /**
     * O token de atualização utilizado para obter um novo token de acesso.
     */
    public refresh_token: string;

    /**
     * O tipo do token (por exemplo, Bearer).
     */
    public token_type: string;

    /**
     * O tempo de expiração do token em segundos.
     */
    public expires_in: number;
}